import { useLazyQuery, useQuery } from "@apollo/client";
import { Layout, Space, Card, PageHeader, Row, Col, Select, Tabs, Divider } from "antd";
import { useEffect } from "react";

import { PROJECT_LIST_QUERY, PROJECT_QUERY } from "../../helpers/graphql/project";
import { EndpointInfo } from "../../components/dashboard/endpointInfo";
import { SubgraphInfo } from "../../components/dashboard/subgraphInfo";
import { ProjectInfo } from "../../components/dashboard/projectInfo";

const { TabPane } = Tabs;

export function Dashboard() {
  const { loading, data } = useQuery(PROJECT_LIST_QUERY);
  const projects = data?.projects;

  const [queryProject, { loading: loadingProject, data: projectData }] =
    useLazyQuery(PROJECT_QUERY);

  const project = projectData?.project;

  useEffect(() => {
    if (projects?.length > 0) {
      queryProject({ variables: { projectId: projects[0].value } });
    }
  }, [queryProject, projects]);

  return (
    <Layout className="content">
      <Layout.Header className="content-header">
        <Row>
          <Col>
            <PageHeader className="page-title" title="Dashboard" />
          </Col>
          <Col>
            {!loadingProject && project ? (
              <Select
                size="middle"
                defaultValue={project?.id}
                onChange={(value) => {
                  queryProject({ variables: { projectId: value } });
                }}
                options={projects}
              />
            ) : null}
          </Col>
        </Row>
      </Layout.Header>
      <Layout.Content className="content-body">
        {loading ? (
          <Card loading={true} className="card-loading" />
        ) : (
          <Space direction="vertical" style={{ width: "100%" }}>
            <Card>
              {project ? <ProjectInfo project={project} /> : null}
              <Divider />
              <Tabs defaultActiveKey="1">
                <TabPane tab="Subgraph" key="1">
                  {project ? <SubgraphInfo project={project} /> : null}
                </TabPane>
                <TabPane tab="RPC" key="2">
                  {project ? <EndpointInfo project={project} /> : null}
                </TabPane>
              </Tabs>
            </Card>
          </Space>
        )}
      </Layout.Content>
    </Layout>
  );
}
